module.exports = __webpack_public_path__ + "assets/img/tit4.1be791b8.png";